import { Component, createRef } from "react";
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";


import HeaderSistema from "./components/HeaderSistema";
import Constante from "../../util/Constante";
import Util from "../../util/Util";
import Endereco from "lirida-back-service/Servicos/Endereco/Endereco";
import GoogleAPI from 'lirida-back-service/Servicos/Google/GoogleAPI';
import Pessoa from "lirida-back-service/Servicos/Pessoa/Pessoa";
import PessoaService from "lirida-back-service/Servicos/Pessoa/PessoaService";
import Pesquisa from "lirida-back-service/Servicos/Pesquisa/Pesquisa";


export default class Condominio extends Component {

  util = new Util();
  toast = createRef();
  constante = new Constante();
  googleApi = new GoogleAPI(this.constante.token, this.constante.url_base);
  inputRef = createRef();
  pessoaService = new PessoaService(this.constante.token, this.constante.url_base);

  state = {
    pessoaUsuario: new Pessoa(),
    pessoaCondominio: new Pessoa(),
    endereco: new Endereco(),
    carregando: false,
    pesquisaEnderecoVisivel: false,
    conteudo: '',

    //LISTAS
    listaCondominio: [],
    listaEndereco: [],

    //MODALS
    vModalNovo: false,
    //INPUT ERROR
    inputError: {
      nome: false,
      email: false,
      telefone: false,
      endereco: false,
    },

    //FILTROS
    filtro: {
      nome: '',
      dataCadastroInicial: '',
      dataCadastroFinal: '',
    }
  }

  componentDidMount() {
    this.iniciar();
  }


  async iniciar() {
    let pessoaUsuario = await this.util.buscarLocalStorage("PESSOA_USUARIO");
    this.listar();

    this.setState({
      pessoaUsuario: pessoaUsuario
    })
  }

  async listar() {
    let listaPesquisa = [];

    this.setState({ carregando: true });

    let pesquisa = new Pesquisa();
    pesquisa.campo = "pessoa.seq_usuario";
    pesquisa.conteudo = this.constante.seqUsuario;
    pesquisa.operacao = '';
    pesquisa.tipo = "TEXTO";
    listaPesquisa.push(pesquisa);

    pesquisa = new Pesquisa();
    pesquisa.campo = "pessoa.seq_pessoa_perfil";
    pesquisa.conteudo = this.constante.seqPessoaPerfilCondominio;
    pesquisa.operacao = 'AND';
    pesquisa.tipo = "TEXTO";
    listaPesquisa.push(pesquisa);

    if (this.state?.filtro?.nome) {
      pesquisa = new Pesquisa();
      pesquisa.campo = 'pessoa.nome';
      pesquisa.conteudo = this.state?.filtro?.nome;
      pesquisa.operacao = 'AND';
      pesquisa.tipo = 'TEXTO';
      listaPesquisa.push(pesquisa);
    }

    if (this.state.filtro.dataCadastroInicial) {
      pesquisa = new Pesquisa();
      pesquisa.campo = "pessoa.data_cadastro";
      pesquisa.conteudo = this.util.formatarDataBanco(this.state.filtro.dataCadastroInicial);
      pesquisa.operacao = "AND";
      pesquisa.tipo = "DATA_INICIAL";
      listaPesquisa.push(pesquisa);
    }

    if (this.state.filtro.dataCadastroFinal) {
      pesquisa = new Pesquisa();
      pesquisa.campo = "pessoa.data_cadastro";
      pesquisa.conteudo = this.util.formatarDataBanco(this.state.filtro.dataCadastroFinal);
      pesquisa.operacao = "AND";
      pesquisa.tipo = "DATA_FINAL";
      listaPesquisa.push(pesquisa);
    }

    let retornoListaCondominio = await this.pessoaService.listarComFiltro(listaPesquisa);
    let ListaCondominio = retornoListaCondominio.objeto;

    this.setState({
      listaCondominio: ListaCondominio,
      carregando: false,
    })
  }

  async salvar(pPessoa) {

    let endereco = this.state.endereco;
    let inputError = this.state.inputError;
    let inputOK = true;
    let pessoaCondominio = pPessoa;

    if (!pessoaCondominio) {
      pessoaCondominio = this.state.pessoaCondominio;
    }

    Object.keys(inputError).forEach(pKey => inputError[pKey] = false);

    if (!pessoaCondominio.nome) {
      inputError.nome = true;
    }

    if (!pessoaCondominio.emailPlataformaLirida) {
      inputError.email = true;
    }

    if (!pessoaCondominio.telefonePlataformaLirida) {
      inputError.telefone = true;
    }

    if (!pessoaCondominio.tags0) {
      inputError.endereco = true;
    }

    Object.keys(inputError).forEach(pKey => {
      if (inputError[pKey] === true) {
        inputOK = false;
      }
    });

    if (!inputOK) {
      this.setState({ inputError: inputError });
      return;
    }

    this.setState({ carregando: true });

    pessoaCondominio.seqUsuario = this.constante.seqUsuario;
    pessoaCondominio.seqPessoaPerfil = this.constante.seqPessoaPerfilCondominio;
    pessoaCondominio.situacao = "ATIVO";
    pessoaCondominio.seqTabelaPreco = this.constante.seqTabelaPrecoPadrao;

    let retornoPessoa = await this.pessoaService.salvar(pessoaCondominio);
    pessoaCondominio = retornoPessoa.objeto;

    console.log(pessoaCondominio);

    endereco.seqUsuario = this.constante.seqUsuario;
    endereco.seqPessoa = pessoaCondominio._seqPessoa;

    let retornoEndereco = await this.pessoaService.salvarEndereco(endereco);
    endereco = retornoEndereco.objeto;

    pessoaCondominio.seqEnderecoPrincipal = endereco._seqEndereco;

    await this.pessoaService.salvar(pessoaCondominio);

    this.setState({
      pessoaCondominio: new Pessoa(),
      conteudo: '',
      vModalNovo: false,
      carregando: false,
    });

    window.open("/sistema/condominio_detalhe?id=" + pessoaCondominio._seqPessoa);
  }


  async listarEndereco(pTexto) {
    if (pTexto.length < 3) return;

    let retornoListaEndereco = await this.googleApi.listarEndereco(pTexto);
    this.setState({ listaEndereco: retornoListaEndereco.predictions });
  }

  async buscarEndereco(pEndereco) {
    let retornoEndereco = await this.googleApi.buscarEndereco(pEndereco.place_id);
    let endereco = this.state.endereco;

    retornoEndereco.result.address_components.forEach(pEndereco => {
      if (pEndereco.types.includes("street_number")) {
        endereco.numero = pEndereco.long_name;
      }
      if (pEndereco.types.includes("route")) {
        endereco.logradouro = pEndereco.long_name;
      }
      if (pEndereco.types.includes("sublocality_level_1")) {
        endereco.bairro = pEndereco.long_name;
      }
      if (pEndereco.types.includes("administrative_area_level_2")) {
        endereco.cidade = pEndereco.long_name;
      }
      if (pEndereco.types.includes("administrative_area_level_1")) {
        endereco.estado = pEndereco.long_name;
        endereco.uf = pEndereco.short_name;
      }
      if (pEndereco.types.includes("country")) {
        endereco.pais = pEndereco.long_name;
      }
      if (pEndereco.types.includes("postal_code")) {
        endereco.cep = pEndereco.long_name;
      }
    });

    endereco.latitude = retornoEndereco.result.geometry.location.lat;
    endereco.longitude = retornoEndereco.result.geometry.location.lng;

    console.log(endereco);

    this.setState({
      endereco: endereco,
      pesquisaEnderecoVisivel: false,
      listaEndereco: [],
      conteudo: pEndereco.description,
      pessoaCondominio: {
        ...this.state.pessoaCondominio,
        tags0: pEndereco.description,
        latitude: endereco.latitude,
        longitude: endereco.longitude,
      }
    });
  }

  resetarInputs() {
    let inputError = this.state.inputError;
    let listaKey = Object.keys(inputError);
    listaKey.forEach(key => inputError[key] = false);

    this.setState({
      endereco: new Endereco(),
      pessoaCondominio: new Pessoa(),
      conteudo: '',
      vModalNovo: false,
      inputOK: true
    })
  }


  render() {
    return <div>
      <HeaderSistema />
      <main style={{ width: "98%", margin: "20px auto" }}>
        <Toast ref={this.toast} />
        <div
          style={{
            border: "1px solid lightgray",
            padding: 20,
            borderRadius: 3,
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div>
            <h1 style={{ fontSize: 22, margin: 0 }}>Condomínios</h1>
            <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Condomínios</h2>
          </div>

          <Button
            onClick={() => this.setState({ vModalNovo: true })}
            label="Novo"
            style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }} />
        </div>

        {/* MODAL NOVO */}
        <Dialog
          header="Novo condomínio"
          visible={this.state.vModalNovo}
          style={{ width: 1000 }}
          onHide={() => this.resetarInputs()}
        >

          <div style={{ border: '1px solid lightgray', padding: '20px 10px', borderRadius: 3, marginTop: 20, gap: 20 }}>

            <div style={{ display: 'grid', gridTemplateColumns: "1fr 1fr 1fr", gap: 20 }}>
              <div>
                <label>Nome</label><br />
                <InputText
                  style={{ width: '100%', borderColor: this.state.inputError.nome && 'red' }}
                  onChange={pEvento => this.setState({
                    pessoaCondominio: {
                      ...this.state.pessoaCondominio,
                      nome: pEvento.target.value
                    }
                  })}
                  value={this.state.pessoaCondominio.nome || ""}
                />
                {this.state.inputError.nome && <small style={{ color: 'red' }}>Nome inválido</small>}
              </div>
              <div>
                <label>Email</label><br />
                <InputText
                  style={{ width: '100%', borderColor: this.state.inputError.email && 'red' }}
                  onChange={pEvento => this.setState({
                    pessoaCondominio: {
                      ...this.state.pessoaCondominio,
                      emailPlataformaLirida: pEvento.target.value
                    }
                  })}
                  value={this.state.pessoaCondominio.emailPlataformaLirida || ""}
                />
                {this.state.inputError.email && <small style={{ color: 'red' }}>Email inválido</small>}
              </div>
              <div>
                <label>Telefone</label><br />
                <InputText
                  style={{ width: '100%', borderColor: this.state.inputError.telefone && 'red' }}
                  type="tel"
                  onChange={pEvento => this.setState({
                    pessoaCondominio: {
                      ...this.state.pessoaCondominio,
                      telefonePlataformaLirida: this.util.formatarTelefone(pEvento.target.value)
                    }
                  })}
                  value={this.state.pessoaCondominio.telefonePlataformaLirida || ""}
                />
                {this.state.inputError.telefone && <small style={{ color: 'red' }}>Telefone inválido</small>}

              </div>
            </div>

            <div style={{ width: "100%", marginTop: 20 }}>
              <label>Endereço</label><br />
              <div>
                <span className="p-input-icon-left" style={{ width: '100%' }}>
                  {!this.state.pesquisaEnderecoVisivel && this.state.endereco.logradouro ?
                    <i className="pi pi-check" />
                    :
                    <i className="pi pi-search" />
                  }
                  <InputText
                    style={{ width: '100%', borderColor: this.state.inputError.endereco && 'red', marginTop: 5 }}
                    onChange={pEvento => {
                      this.setState({
                        conteudo: pEvento.target.value,
                        pesquisaEnderecoVisivel: true
                      });
                      this.listarEndereco(pEvento.target.value)
                    }}
                    value={this.state.conteudo || ""} />
                </span>
                {this.state.inputError.endereco && <small style={{ color: 'red' }}>Endereço inválido</small>}
              </div>
            </div>

            {this.state.listaEndereco.map(pEndereco =>
              <Button
                type="button"
                key={Math.random()}
                label={pEndereco.description}
                className="p-button-link"
                style={{ width: "100%", textAlign: 'left', marginTop: 10 }}
                onClick={() => this.buscarEndereco(pEndereco)} />
            )}
          </div>

          <div style={{ display: "flex", width: "100%", justifyContent: "flex-end", marginTop: 20 }}>
            <Button
              style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
              loading={this.state.carregando}
              label="Salvar"
              onClick={() => this.salvar()}
            />
          </div>
        </Dialog>
        {/* FIM MODAL NOVO */}

        {/* FILTRO */}
        <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, gap: 20, marginTop: 20 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>

            <div>
              <label>Nome</label><br />
              <InputText
                onChange={pTexto => this.setState({
                  filtro: {
                    ...this.state.filtro, nome: pTexto.target.value
                  }
                })}
                value={this.state.filtro.nome || ''}
                placeholder="Nome"
                style={{ width: '100%', height: 40 }}
              />
            </div>


            <div>
              <label>Data cadastro inicial</label><br />
              <Calendar
                onChange={(pTexto) => this.setState({
                  filtro: {
                    ...this.state.filtro, dataCadastroInicial: pTexto.target.value
                  }
                })}
                showButtonBar
                style={{ width: "100%", height: 40 }}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
              />
            </div>

            <div>
              <label>Data cadastro final</label><br />
              <Calendar
                onChange={(pTexto) => this.setState({
                  filtro: {
                    ...this.state.filtro, dataCadastroFinal: pTexto.target.value
                  }
                })}
                showButtonBar
                style={{ width: "100%", height: 40 }}
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
              />
            </div>

          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
            <Button loading={this.state.carregando} label="Buscar" className="p-button-raised"
              onClick={() => this.listar()} style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
            />
          </div>

        </div>
        {/* FIM FILTRO */}


        {/* TABELA */}

        <DataTable
          showGridlines
          removableSort
          paginator
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
          rows={50}
          rowsPerPageOptions={[50, 60, 70, 80, 100]}
          style={{ width: "100%", marginTop: 30 }}
          value={this.state.listaCondominio}
          loading={this.state.carregando}
        >
          <Column
            field="nome"
            header="Nome"
            sortable
            body={pItem => <a href={`/sistema/condominio_detalhe?id=${pItem._seqPessoa}`}>{pItem.nome}</a>} />
          <Column
            field="tags0"
            header="Endereço"
            sortable />

          <Column
            header="Data de cadastro"
            body={item => this.util.formatarData(item.dataCadastro)}
            sortable />
        </DataTable>

        {/* FIM DA TABELA */}

      </main>
    </div >
  }
}